import { ReactNode, useState } from 'react';
import './FlipComponent.scss';
interface FlipCardI {
	frontContent: ReactNode;
	backContent: ReactNode;
	width?: string;
	height?: string;
	className?: string;
	onFlip?: (isFlipped: boolean) => void;
}
export const FlipComponent: React.FC<FlipCardI> = ({
	frontContent,
	backContent,
	className,
	onFlip,
	height = '300px',
	width = '200px'
}) => {
	const [isFlipped, setIsFlipped] = useState<boolean>(false);
	const handleFlip = () => {
		const newFlippedState = !isFlipped;
		setIsFlipped(newFlippedState);
		if (onFlip) {
			onFlip(newFlippedState);
		}
	};
	return (
		<div
			className={`flip-card-container ${className}`}
			style={{ width, height }}
			onClick={handleFlip}
		>
			<div className={`flip-card ${isFlipped ? 'flipped' : ''} `}>
				<div className='flip-card-front'>{frontContent}</div>
				<div className='flip-card-back'>{backContent}</div>
			</div>
		</div>
	);
};
